"use client";

import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { useQueryState } from "nuqs";

type SearchBarProps = {
  product: string;
};

export default function SearchBar() {
  const [search, setSearch] = useQueryState("query", {
    history: "replace",
    shallow: true,
  });

  return (
    <div className="relative flex items-center">
      <Search className="absolute left-3 h-5 w-5 text-muted-foreground" />
      <Input
        placeholder="Search products..."
        className="pl-10 h-10"
        value={search ?? ""}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  );
}
